import React, { Fragment } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { MainRoute } from './mainRoutes';

interface Props {
  routes: MainRoute[];
}

const Routes = ({ routes }: Props) => {
  return (
    <Switch>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Component = route.component || Fragment;
        const Provider = route.provider || Fragment;

        return (
          <Route
            key={i.toString()}
            path={route.path}
            exact={route.exact}
            render={(props) => (
              <Guard>
                <Provider>
                  <Component {...props} />
                </Provider>
              </Guard>
            )}
          />
        );
      })}
      <Redirect from="*" to="/" />
    </Switch>
  );
};

export default Routes;
